import { MonitorParameterExt } from "@/global/interface/monitor-object/monitor-parameter"
import "./index.less"
import { useEffect, useState } from "react"
import TnInput from "@/global/components/input/tn-input"
import { InlineMath } from 'react-katex';
import { Button, Select, Switch, message } from "antd";
import { updateExtParameter } from "@/api/monitor-object/monitor-parameter";

interface IProps {
    paramId: number
    data: MonitorParameterExt
    onClickCancel: () => void
    onClickConfirm: (param: MonitorParameterExt) => void
}

const paramList = [
    { label: "size_1", key: "size_1", default: "1000" },
    { label: "size_2", key: "size_2", default: "1000" },
    { label: "外点剔除可调阈值 ", key: "threshold", default: "0.5" },
    { label: "Canny-边缘检测低阈值", key: "lowThreshold", default: "50" },
    { label: "Canny-边缘检测高阈值", key: "highThreshold", default: "150" },
    { label: "depthConfidence", key: "depthConfidence", default: "0.95" },
    { label: "widthConfidence", key: "widthConfidence", default: "0.99" },
    { label: "filterThreshold", key: "filterThreshold", default: "0.1" },
    { label: "detectionThreshold", key: "detectionThreshold", default: "0.0005" },
    { label: "基准线（距离）", key: "baseLine", default: "" }
]

export function ExtParamPanel(props: IProps) {

    const { paramId, data, onClickCancel, onClickConfirm } = props

    const [extParam, setExtParam] = useState<MonitorParameterExt>(null)

    useEffect(() => {
        setExtParam(data || {})
    }, [data])

    const onChangeParamDetail = (key: string, value: any) => {
        extParam[key] = value
        setExtParam({ ...extParam })
    }

    const onClickConfirmEdit = () => {
        updateExtParameter(paramId, extParam).then(res => {
            if (res.data < 0) {
                message.warning(getWarningMessage(res.data))
                onClickConfirm(extParam)
            } else {
                message.success("发送同步信号成功")
                onClickConfirm(extParam)
            }
        })
    }

    const getWarningMessage = (status: number) => {
        switch (status) {
            case -1:
                return "未选择计算方法";
            case -2:
                return "参数未绑定摄像头";
            case -3:
                return "摄像头未绑定工控机";
            case -4:
                return "工控机未配置imei";
            case -5:
                return "现场工控机未建立连接";
            case -6:
                return "向工控机发送数据失败";
            default:
                break;
        }
    }


    return (
        <div className="ext-param-panel-main">
            <div className="panel-body">
                <div className="item">
                    <div className="label">
                        开启边界
                    </div>
                    <div className="value">
                        <Switch
                            onChange={(e) => {
                                let useCanny = extParam?.useCanny == 1 ? 0 : 1
                                onChangeParamDetail("useCanny", useCanny)
                            }}
                            value={(extParam?.useCanny === null || extParam?.useCanny === undefined) ? true : extParam.useCanny === 1}
                            size="small"
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        边界大小
                    </div>
                    <div className="value">
                        <TnInput
                            value={extParam?.radius || "2.0"}
                            style={{ width: '240px' }}
                            suffix={<InlineMath math={"px"} />}
                            onTextChange={(value) => {
                                onChangeParamDetail("radius", value)
                            }}
                            size="small"
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        识别方法
                    </div>
                    <div className="value">
                        <Select
                            style={{ width: 240 }}
                            size="small"
                            value={extParam?.method || 2}
                            options={[
                                { label: "SIFT", value: 1 },
                                { label: "SUPERPOINT", value: 2 }
                            ]}
                            onChange={(e) => {
                                onChangeParamDetail("method", e)
                            }}
                        />
                    </div>
                </div>
                {paramList.map(param => (
                    <div className="item" key={param.key}>
                        <div className="label">
                            {param.label}
                        </div>
                        <div className="value">
                            <TnInput
                                value={(extParam && extParam[param.key]) || param.default}
                                style={{ width: '240px' }}
                                // suffix={<InlineMath math={"px"} />}
                                onTextChange={(value) => {
                                    onChangeParamDetail(param.key, value)
                                }}
                                size="small"
                            />
                        </div>
                    </div>
                ))}
            </div>

            <div className="btn-area">
                <Button
                    type="primary"
                    size="small"
                    children={<>确定</>}
                    onClick={() => {
                        onClickConfirmEdit()
                    }}
                />
                <Button
                    type="default"
                    size="small"
                    onClick={onClickCancel}
                    children={<>取消</>}
                />
            </div>


        </div>
    )
}